import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatRating } from "@/utils/movies";

interface MovieCardProps {
  movie: Movie;
  index?: number;
}

export default function MovieCard({ movie, index = 0 }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block animate-fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.cover}
          alt={movie.title}
          title={`${movie.title} 高清影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent" />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-1.5 py-0.5 font-label text-[11px] font-semibold text-background-50">
          {movie.quality}
        </span>
        <span className="absolute right-2 top-2 inline-flex items-center gap-0.5 rounded-md bg-accent-500 px-1.5 py-0.5 font-label text-[11px] font-bold text-background-50">
          <i className="ri-star-fill text-[10px]" aria-hidden="true" />
          {formatRating(movie.rating)}
        </span>
        <div className="absolute inset-x-0 bottom-0 p-2.5">
          <p className="line-clamp-1 text-xs text-background-100">{movie.genres.join(" · ")}</p>
        </div>
      </div>
      <div className="mt-2">
        <h3 className="line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-0.5 text-xs text-foreground-500">
          {movie.year} · {movie.region}
        </p>
      </div>
    </Link>
  );
}